import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("g", {
  id: "Group_7470",
  "data-name": "Group 7470",
  transform: "translate(-0.701)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "icon-sort-up",
    "data-name": "Path 7612",
    d: "M19.634,17.546,17.37,19.811a.647.647,0,0,1-.915,0L14.19,17.546a.647.647,0,0,1,.915-.915l1.16,1.16V8.647a.647.647,0,1,1,1.294,0v9.144l1.16-1.16a.647.647,0,0,1,.915.915Z",
    transform: "translate(-6.475 -8)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "icon-sort-down",
    "data-name": "Path 296",
    d: "M19.635,10.455,17.37,8.19a.647.647,0,0,0-.915,0L14.19,10.455a.647.647,0,0,0,.915.915l1.16-1.16v9.144a.647.647,0,0,0,1.294,0V10.21l1.16,1.16a.647.647,0,0,0,.915-.915Z",
    transform: "translate(-13.299 -8)"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconSort',
  props: {
    sort: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12.648",
    height: "11",
    viewBox: "0 0 12.648 12",
    class: _normalizeClass(_ctx.sort)
  }, _hoisted_2, 2))
}
}

})